import { useEffect, useState } from "react";
import { get } from "./api";
import type { Curso, Diferencial, Serie, TabelaValor } from "./tipos";

export interface DadosApoio {
  cursos: Curso[];
  series: Serie[];
  diferenciais: Diferencial[];
  valores: TabelaValor[];
  /** % do desconto que vira abatimento por pagar em dia — vem do servidor. */
  descontoAntecipadoPct: number | null;
  carregando: boolean;
  erro: string;
}

/** Carrega cursos, séries, diferenciais e tabelas de valores — usados pelo formulário. */
export function useDadosApoio(): DadosApoio {
  const [d, setD] = useState<Omit<DadosApoio, "carregando" | "erro">>({
    cursos: [], series: [], diferenciais: [], valores: [], descontoAntecipadoPct: null,
  });
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  useEffect(() => {
    Promise.all([
      get<Curso[]>("/api/tabelas/cursos"),
      get<Serie[]>("/api/tabelas/series"),
      get<Diferencial[]>("/api/tabelas/diferenciais"),
      get<TabelaValor[]>("/api/tabelas/valores"),
      get<{ descontoAntecipadoPct: number }>("/api/tabelas/configuracao"),
    ])
      .then(([cursos, series, diferenciais, valores, cfg]) =>
        setD({ cursos, series, diferenciais, valores, descontoAntecipadoPct: cfg.descontoAntecipadoPct }),
      )
      .catch((e) => setErro(e.message))
      .finally(() => setCarregando(false));
  }, []);

  return { ...d, carregando, erro };
}
